import React from 'react';
import DocumentTypeItem from './DocumentTypeItem';
import styles from '../../../styles/DocumentManagement.module.css';

interface DocumentTypesListProps {
  types: any[];
  isCompanyMode?: boolean;
}

const DocumentTypesList: React.FC<DocumentTypesListProps> = ({
  types,
  isCompanyMode = false,
}) => (
  <div className={styles.document_types_list}>
    {types.map(type => (
      <DocumentTypeItem
        key={type.id}
        type={type}
        isCompanyMode={isCompanyMode}
      />
    ))}
  </div>
);

export default DocumentTypesList;

